import { readTeantConfiguration } from './metadata-storage'

export class TenantPath {
  private enabledCustomizations: string[]
  private enabledMicroservices: string[]
  private allMicroserviceEnabled: boolean
  public TrainingEnabled: boolean
  public TenantClinicLevelRolesEnabled: boolean
  public LastLoginEnabled: boolean
  public ExternalId?: string
  public Country?: string
  public ForceClinicCreationToSameTenantCountry?: boolean
  public componentLibrary?: string

  constructor() {
    const tenant = readTeantConfiguration()
    const tenantEnabledMicroservices = tenant.enabledMicroservices ?? []
    this.enabledMicroservices = tenantEnabledMicroservices.map((ms: string) => ms.trim().toLowerCase())
    this.allMicroserviceEnabled = tenant.allMicroserviceEnabled
    const tenantEnabledCustomization = tenant.enabledCustomizations ?? []
    this.enabledCustomizations = tenantEnabledCustomization.map((customization: string) =>
      customization.trim().toLowerCase(),
    )
    this.TrainingEnabled = tenant.trainingEnabled
    this.TenantClinicLevelRolesEnabled = tenant.tenantClinicLevelRolesEnabled
    this.LastLoginEnabled = tenant.lastLoginEnabled
    this.ExternalId = tenant?.externalId
    this.Country = tenant?.country
    this.ForceClinicCreationToSameTenantCountry = tenant?.forceClinicCreationToSameTenantCountry
    this.componentLibrary = tenant.componentLibrary
  }

  public IsMicroServiceEnabled(msName: string): boolean {
    if (this.allMicroserviceEnabled) {
      return true
    }

    const isMicroServiceEnabled = this.enabledMicroservices.find((ms) => ms === msName.toLowerCase()) !== undefined
    return isMicroServiceEnabled
  }

  public IsCustomizationEnabled(customizationName: string): boolean {
    const isCustomizationEnabled =
      this.enabledCustomizations.find((customization) => customization === customizationName.toLowerCase()) !==
      undefined
    return isCustomizationEnabled
  }
}
